import { FilterState, useOpenTradesSearchFilters } from './usePageParams';
import { useEffect, useState } from 'react';
import { useDebouncedState } from 'utils/useDebounce';
import {
  ArrowTopRightOnSquareIcon,
  FunnelIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline';
import { isValidAddress } from 'helpers/api/web3Utils';
import {
  ActivteFiltersBar,
  FilterTag,
  SelectFiltersBar,
} from '../../../components/filters';
import TextInput from '../../../components/inputs/text-input/text-input';
import { useGlobalChain } from 'modules/routing/chainProvider';
import { isValidUUIDv4 } from '../../../trade-monitor/SnipesFilters';
import Button from 'modules/shared-components/button/button';
import { useHistory } from 'react-router-dom';
import { screenGte, useMediaQuery } from 'modules/media/use-media-query';

export const OpenTradesFiltersBar = ({
  isTerminal,
}: {
  isTerminal?: boolean;
}) => {
  const { filtersState: filters, setFilters } = useOpenTradesSearchFilters();
  const [selectedChain] = useGlobalChain();
  const [address, debouncedAddress, setAddress] = useDebouncedState('', 250);
  const [botId, debouncedBotId, setBotId] = useDebouncedState('', 250);
  const [botIdError, setBotIdError] = useState(false);

  useEffect(() => {
    if (debouncedBotId) {
      setBotIdError(!isValidUUIDv4(debouncedBotId));
      if (isValidUUIDv4(debouncedBotId)) {
        updateFilters({
          botId: debouncedBotId,
        });
      }
    }
  }, [debouncedBotId]);
  const [addressError, setAddressError] = useState(false);

  useEffect(() => {
    if (debouncedBotId) {
      setBotIdError(!isValidUUIDv4(debouncedBotId));
      if (isValidUUIDv4(debouncedBotId)) {
        updateFilters({
          botId: debouncedBotId,
        });
      }
    }
  }, [debouncedBotId]);

  useEffect(() => {
    if (debouncedAddress) {
      setAddressError(!isValidAddress(debouncedAddress, selectedChain));
      if (isValidAddress(debouncedAddress, selectedChain)) {
        updateFilters({
          tokenAddress: debouncedAddress,
        });
      }
    }
  }, [debouncedAddress]);

  const handleAddressInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    const inputValue = e.target.value;
    setAddress(inputValue);
    if (!inputValue) {
      setAddressError(false);
      updateFilters({
        tokenAddress: undefined,
      });
    }
  };

  const updateFilters = (update: Partial<FilterState>) => {
    setFilters({ ...filters, ...update });
  };

  const handleBotIdInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    const inputValue = e.target.value;
    setBotId(inputValue);
    if (!inputValue) {
      setBotIdError(false);
      updateFilters({
        botId: undefined,
      });
    }
  };
  const history = useHistory();
  const isDesktop = useMediaQuery(screenGte.large);

  return (
    <div className="xxs:mx-1 space-y-1 lg:mx-0">
      <SelectFiltersBar
        className="xxs:justify-start space-x-2"
        icon={
          <div className="xxs:p-1">
            <FunnelIcon aria-hidden="true" width={16} height={16} />
          </div>
        }
        sort={
          <div className="flex gap-x-2 items-center xxs:px-2">
            <div>
              <TextInput
                name="address"
                inputSize="xs"
                error={addressError ? 'Address not valid' : ''}
                value={address}
                hideErrorMessage={true}
                prefix={
                  <MagnifyingGlassIcon className="xxs:w-4 xxs:text-dex-white-secondary" />
                }
                onChange={handleAddressInputChange}
                placeholder="Token Address"
              />
            </div>
            <div>
              <TextInput
                name="botId"
                value={botId}
                hideErrorMessage={true}
                inputSize="xs"
                error={botIdError ? 'Bot format not valid' : ''}
                prefix={
                  <MagnifyingGlassIcon className="w-4 text-dex-white-secondary" />
                }
                onChange={handleBotIdInputChange}
                placeholder="Bot Id"
              />
            </div>
            {isTerminal && (
              <Button
                type="button"
                onClick={() =>
                  history.push({
                    pathname: '/dex/dashboard/open-trades',
                    state: {
                      sourceUrl: `${history.location.pathname}${history.location.search}`,
                    },
                  })
                }
                className="hidden lg:block xxs:text-dex-white-secondary hover:text-dex-white xxs:p-0"
              >
                <div className="xxs:flex xxs:space-x-1 items-center font-normal">
                  <div className=" normal-case">Expand</div>
                  <ArrowTopRightOnSquareIcon className="w-4 h-4" />
                </div>
              </Button>
            )}
          </div>
        }
      >
        <div className="xxs:space-y-2" />
      </SelectFiltersBar>

      {!isDesktop && (
        <ActivteFiltersBar>
          {filters.tokenAddress && (
            <FilterTag
              onRemove={() => {
                setAddress('');
                return updateFilters({
                  tokenAddress: undefined,
                });
              }}
              label={filters.tokenAddress || ''}
            />
          )}
        </ActivteFiltersBar>
      )}
    </div>
  );
};
